import { useSnackbar } from "notistack";
import { Box, Paper, SelectChangeEvent, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import errorFormat from "../../utils/errorFormat";
import { useNavigate, useParams } from "react-router-dom";
import configUrls from "../../config/configUrls";
import { ISprocesso, Processo } from "../../types/processo/Processo";
import { useCreateProcessoMutation } from "./processoApiSlice";
import { ProcessoForm } from "./ProcessoForm";
import { TipoProcesso } from "../../types/tipoProcesso/TipoProcesso";
import { type } from "os";
import { RootState } from "../../app/store";
import { useSelector } from "react-redux";
import { UsuarioLogadoGet } from "../../utils/usuarioEstaLogado";
import { ProcessoDTO } from "../../types/processo/ProcessoDTO";



export const ProcessoCreate = () => {

    const [processo, setProcesso] = useState<Processo>(ISprocesso);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar()
    const [createProcesso, status] = useCreateProcessoMutation();
    const navigate = useNavigate();
    let response: Processo;


    const [isDisabled, setIsDisabled] = useState<boolean>(false);
    //ler do RTK o processo selecionado    
    const { processoSelecionado } = useSelector((state: RootState) => state.processoSelecionado);

    const { id: usuarioLogadoId } = UsuarioLogadoGet();

    const { id } = useParams();
    const isEdit = id ? true : false;
    //esta dando erro na hora de gravar o processo


    useEffect(() => {
        if (isEdit) {
            if (!processoSelecionado) {
                alert("Nenhum processo foi previamente selecionado para edição");
                window.location.href = configUrls.PROCESSO_LIST_RT
                setIsDisabled(false)
            } else {
                setProcesso(processoSelecionado);
                if (processoSelecionado.usuario.id === usuarioLogadoId) {
                    setIsDisabled(false)
                } else {
                    setIsDisabled(true)
                }
            }
        }
    }, [processoSelecionado, isEdit]);




    const handleChangeSelect = (e: SelectChangeEvent) => {
        const value: string = e.target.value as string;

        if (value === "SIGILOSO" || value === "RESTRITO" || value === "PUBLICO") {
            setProcesso((prev) => ({
                ...prev,
                'nivelAcesso': value,
            }));
        } else {
            enqueueSnackbar("Selecione um nível de acesso válido!", { variant: "error" })
            setProcesso((prev) => ({ ...prev }));
            return;
        }

    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const cursorPosition = e.target.selectionStart;

        setProcesso((prev) => ({
            ...prev,
            [name]: value.toUpperCase(),
        }));

        // Aguarde até que o DOM seja atualizado
        setTimeout(() => {
            const input = e.target;
            input.setSelectionRange(cursorPosition, cursorPosition);
        }, 0);
    };

    const handleSearchChange = (tipoProcesso: TipoProcesso) => {

        if (tipoProcesso) {

            setProcesso((prev) => ({
                ...prev,
                tipoProcesso: {
                    ...prev.tipoProcesso, // Preserva o que já está no tipoProcesso
                    id: tipoProcesso.id,
                    nome: tipoProcesso.nome,
                    descricao: tipoProcesso.descricao,
                }
            }));
        }
    };

    async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        if (processo.tipoProcesso == null || processo.tipoProcesso.id.length === 0) {
            enqueueSnackbar("Tipo de processo inválido!", { variant: "error" })
            return
        }

        const params: ProcessoDTO = {
            id: isEdit ? processo.id : null,
            especificacao: processo.especificacao,
            observacao: processo.observacao,
            nivelAcesso: processo.nivelAcesso,
            tipoProcessoID: processo.tipoProcesso.id,
        }



        const retorno = await createProcesso(params);
        if (retorno) {
            if ('data' in retorno) {
                response = retorno.data as Processo;
                //enqueueSnackbar("Registro incluído com sucesso!", { variant: "success" })
                navigate(configUrls.PROCESSO_FORM_VIEW_LK + response.id);

            }
        }
    }

    useEffect(() => {
        if (status.isError) {
            enqueueSnackbar("Registro não incluído!", { variant: "error" })
            const erroReturn: string = errorFormat(status);
            enqueueSnackbar(erroReturn, { variant: "error" })

        }

        if (status.isSuccess) {
            enqueueSnackbar("Registro incluído!", { variant: "success" })

        }
    }, [status]);








    return (



        <>


            <Paper>

                {!isEdit ? (
                    <Typography variant="h6" component="h1" sx={{ padding: 2 }}>
                        Iniciar Processo
                    </Typography>
                ) : (
                    <Typography variant="h6" component="h1" sx={{ padding: 2 }}>
                        Visualizar / Alterar o Processo de número: {processo?.numeroProcesso}
                    </Typography>
                )}

                <ProcessoForm
                    data={processo}
                    isdisabled={isDisabled}
                    //isLoading={status.isLoading}
                    handleSubmit={handleSubmit}
                    handleChange={handleChange}
                    handleChangeSelect={handleChangeSelect}
                    handleSearchChange={handleSearchChange}
                />

            </Paper>

        </>

    );

};
